import { render, staticRenderFns } from "./RosterStatusTypeCreate.vue?vue&type=template&id=ef63f820&scoped=true&"
import script from "./RosterStatusTypeCreate.vue?vue&type=script&lang=js&"
export * from "./RosterStatusTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./RosterStatusTypeCreate.vue?vue&type=style&index=0&id=ef63f820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef63f820",
  null
  
)

export default component.exports